import React, { MouseEventHandler, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { MEMBERSHIP_PLANS } from "../../constants/constants"

const DowngradeModal = ({
    show,
    customer,
    handleClose,
    handleSubmit
}: {
    show: string
    customer: Record<string, any>
    handleClose: () => void
    handleSubmit: Function
}) => {
    const { t, i18n } = useTranslation()
    const [target, setTarget] = useState("")

    return (
        <Modal
            show={show === "downgradeModal"}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header className="mx-2" closeButton>
                <Modal.Title>{t("Downgrade a Business User")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 mb40 mt-3 py-0">
                <Form className="form">
                    <div>
                        <p className="modal-description pb-3">
                            {t("Downgrade a Business User to premium or basic.")}
                        </p>
                        <Row className="w-100 mb-2">
                            <Col lg={12} className="label required">
                                {t("Current Plan")}
                            </Col>
                        </Row>
                        <Row className="w-100 mb-2 px-0">
                            <Col lg={12} className="label">
                                <Form.Control
                                    className="w-100"
                                    value={MEMBERSHIP_PLANS[customer?.user_type]}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row className="w-100 mb-2">
                            <Col className="label required">{t("Tagret Plan")}</Col>
                        </Row>
                        <Row className="w-100 mb-2 mx-0">
                            <Col className="label px-0">
                                <select
                                    id="target"
                                    name="target"
                                    value={target}
                                    onChange={(e) => setTarget(e.target.value)}
                                    className="form-control select-column">
                                    <option>--</option>
                                    {[MEMBERSHIP_PLANS.P, MEMBERSHIP_PLANS.B]?.map((plan: string) => (
                                        <option value={plan} id={`plan-${plan}`}>
                                            {plan}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Close")}
                </Button>

                <Button
                    onClick={() => {
                        handleSubmit(customer?.id, target.toLowerCase())
                    }}
                    className="btn btn-primary"
                    type="submit">
                    {t("Downgrade")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DowngradeModal
